<template>
  <div class="scope-details">
    <v-breadcrumbs :items="breadcrumb" large></v-breadcrumbs>
    <v-divider></v-divider>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <ScopeEditionForm
        :uuid="scope ? scope.uuid : ''"
        :name="scope ? scope.name : ''"
        :description="scope?scope.description : ''"
        v-on:refresh="refresh"
        v-on:save="updateScope"
        ref="scopeEditionForm"
      />
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <ScopeEditionCurrentRolesTable :currentRoles="currentRoles" v-on:remove="removeRole" />
        </v-col>
        <v-col cols="12" md="6">
          <ScopeEditionAvailableRolesTable :availableRoles="availableRoles" v-on:add="addRole" />
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import ScopeEditionForm from "@/components/Admin/Scopes/ScopeEditionForm";
import ScopeEditionAvailableRolesTable from "@/components/Admin/Scopes/ScopeEditionAvailableRolesTable";
import ScopeEditionCurrentRolesTable from "@/components/Admin/Scopes/ScopeEditionCurrentRolesTable";

export default {
  name: "ScopeDetails",
  components: {
    ScopeEditionForm,
    ScopeEditionAvailableRolesTable,
    ScopeEditionCurrentRolesTable
  },
  mixins: [mixin],
  data() {
    return {
      scope: {},
      currentRoles: [],
      availableRoles: [],
      snackbar: false,
      errorMessage: ""
    };
  },
  computed: {
    ...mapState({
      isLoading: state => state.scopes.fetchOne.pending,
      fetchError: state => state.scopes.fetchOne.error
    }),
    breadcrumb() {
      return [
        {
          text: "Scopes",
          disabled: false,
          href: "#/admin/scopes"
        },
        {
          text: this.scope ? this.scope.name : "unknown",
          disabled: true
        }
      ];
    }
  },
  methods: {
    ...mapActions("scopes", { fetchOne: "fetchOne" }),
    ...mapActions("scopes", { updateOne: "updateOne" }),
    ...mapActions("scopes", { fetchAllCurrentRoles: "fetchAllCurrentRoles" }),
    ...mapActions("scopes", {
      fetchAllAvailableRoles: "fetchAllAvailableRoles"
    }),
    ...mapActions("scopes", { addRoleToScope: "addRoleToScope" }),
    ...mapActions("scopes", { removeRoleFromScope: "removeRoleFromScope" }),
    refresh() {
      this.fetchOne({ scopeUuid: this.$route.params.scopeId }).then(scope => {
        this.scope = scope;
        this.name = scope.name;
        this.description = scope.description;
      });
      this.fetchAllCurrentRoles({ scopeUuid: this.$route.params.scopeId }).then(
        roles => {
          this.currentRoles = roles;
        }
      );
      this.fetchAllAvailableRoles({
        scopeUuid: this.$route.params.scopeId
      }).then(roles => {
        this.availableRoles = roles;
      });
    },
    updateScope(name, description) {
      this.updateOne({
        scopeUuid: this.$route.params.scopeId,
        name: name,
        description: description
      })
        .then(() => {
          this.refresh();
          this.$refs.scopeEditionForm.saveCallback();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    removeRole(roleUuid, roleName) {
      this.removeRoleFromScope({
        scopeUuid: this.$route.params.scopeId,
        roleUuid: roleUuid,
        roleName: roleName
      }).then(() => {
        this.refresh();
      });
    },
    addRole(roleUuid, roleName) {
      this.addRoleToScope({
        scopeUuid: this.$route.params.scopeId,
        roleUuid: roleUuid,
        roleName: roleName
      }).then(() => {
        this.refresh();
      });
    }
  },
  created() {
    this.refresh();
  }
};
</script>